import { BsExclamationTriangleFill, BsFillCheckCircleFill } from "react-icons/bs"
import styles from "./errorSuccessMessage.module.scss";
import { IStatus } from "../../types";


export const ErrorSuccessMessage = (status: IStatus) => {
    if (status.loading) return null
    if (status.error) return (
        <div className={styles.error} role="alert">
                <p className={styles.errorText}>
                    <span>
                        <BsExclamationTriangleFill />
                    </span>{" "}
                    {status.error}
                </p>
            </div>
    )
    if (status.success) return (
         <div className={styles.success} role="status">
                <p className={styles.successText}>
                    <span>
                        <BsFillCheckCircleFill />
                    </span>{" "}
                    {status.success}
                </p>
            </div>
    )
  
}